import { useAuth as useAuthContext } from "@/contexts/AuthContext";

/**
 * Hook to access authentication context
 * This is a re-export for convenience
 */
export function useAuth() {
  return useAuthContext();
}

